module.exports = __webpack_public_path__ + "img/dzpdf2.9b4a1533.png";